import "hammerjs";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
const PopupWrapper = ({
  Component,
  toShow,
  title,
  closeEventHandler = () => {},
  size = "m",
  backdrop = "true",
  extraClass,
  dialogClassName = `kmw-90 p-5 ${extraClass ? extraClass : ""}`,
  titleClassName = "",
  bodyStyle = {},
  bodyClass = "p-5",
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    closeEventHandler();
  };

  useEffect(() => {
    toShow ? setShow(true) : setShow(false);
  }, [toShow]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size={size}
        backdrop={backdrop}
        dialogClassName={dialogClassName}
      >
        <Modal.Header
          closeButton
          // style={{ padding: "16px" }
        >
          <Modal.Title className={titleClassName}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={bodyClass}
          style={bodyStyle}
        >
          {Component}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PopupWrapper;
